<template>
  <div v-if="showError" class="error-display-container">
    <div class="error-modal-overlay" @click="$emit('close')">
      <div class="error-modal-content" @click.stop>
        <!-- Error Header -->
        <div class="error-header">
          <i class="fa-solid fa-triangle-exclamation error-icon"></i>
          <h3>{{ title }}</h3>
          <button @click="$emit('close')" class="error-close-btn">
            <i class="fa-solid fa-xmark"></i>
          </button>
        </div>

        <!-- Error Message -->
        <div class="error-body">
          <p>{{ message }}</p>
        </div>

        <!-- Actions -->
        <div class="error-footer">
          <button @click="$emit('retry')" class="retry-btn">
            Try Again
          </button>
          <button @click="$emit('close')" class="close-btn">
            Close
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ErrorDisplay",
  
  props: {
    showError: Boolean,
    title: {
      type: String,
      default: "Error"
    },
    message: {
      type: String,
      default: "Something went wrong. Please try again."
    }
  }
};
</script>

<style scoped>
.error-display-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9999;
}

.error-modal-overlay {
  background: rgba(0, 0, 0, 0.5);
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.error-modal-content {
  background: white;
  border-radius: 12px;
  width: 100%;
  max-width: 400px;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
}

/* Error Header */
.error-header {
  background: #ff4757;
  color: white;
  padding: 20px;
  display: flex;
  align-items: center;
  gap: 12px;
}

.error-icon {
  font-size: 24px;
}

.error-header h3 {
  margin: 0;
  flex: 1;
  font-size: 1.2rem;
}

.error-close-btn {
  background: rgba(255, 255, 255, 0.2);
  border: none;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  color: white;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.error-close-btn:hover {
  background: rgba(255, 255, 255, 0.3);
}

/* Error Body */
.error-body {
  padding: 24px;
}

.error-body p {
  margin: 0;
  color: #333;
  line-height: 1.5;
}

/* Error Footer */
.error-footer {
  padding: 20px;
  border-top: 1px solid #eee;
  display: flex;
  gap: 12px;
  justify-content: flex-end;
}

.retry-btn, .close-btn {
  padding: 10px 20px;
  border-radius: 6px;
  font-weight: 600;
  cursor: pointer;
  border: none;
  font-size: 0.95rem;
}

.retry-btn {
  background: #007bff;
  color: white;
}

.retry-btn:hover {
  background: #0056b3;
}

.close-btn {
  background: #6c757d;
  color: white;
}

.close-btn:hover {
  background: #545b62;
}

/* Responsive */
@media (max-width: 480px) {
  .error-modal-content {
    max-width: 100%;
  }
  
  .error-header {
    padding: 16px;
  }
  
  .error-body {
    padding: 20px;
  }
  
  .error-footer {
    padding: 16px;
    flex-direction: column;
  }
  
  .retry-btn, .close-btn {
    width: 100%;
  }
}
</style>